// extracted by mini-css-extract-plugin
export default {"sliderContainer":"ChartControls_sliderContainer__oudzP"};